<template>
  <div>
    <AlertaMsj :alerta-msj="alertaMsj" />
    <div class="container mt-3">
      <mdb-tabs
        :active="0"
        pills
        class="tab-invitaciones"
        color="primary"
        :links="[
          { text: 'Invitar' },
          { text: 'Importar' }]"
      >
        <template :slot="'Invitar'">
          <div class="content-tab mb-1">
            <header
              class="my-2 font-weight-bold text-center"
            >
              Ingrese los correos de invitación
            </header>
            <div class="inputs row justify-content-center">
              <div class="col-11 col-lg-4">
                <mdb-input
                  v-model="nombre"
                  label="Nombre"
                  class="my-1"
                  outline
                />
              </div>
              <div class="col-11 col-sm-7 d-md-none">
                <mdb-input
                  v-model="email"
                  label="Email o Teléfono"
                  class="my-1"
                  outline
                />
              </div>
              <div class="col-11 col-sm-4 d-md-none">
                <div
                  class="md-form md-outline outline-select my-1"
                >
                  <select
                    id="host-select"
                    v-model="host"
                    class="custom-select"
                  >
                    <option value="">
                      Seleccione
                    </option>
                    <option value="@gmail.com">
                      @gmail.com
                    </option>
                    <option value="@hotmail.com">
                      @hotmail.com
                    </option>
                  </select>
                </div>
              </div>
              <mdb-btn
                color="primary"
                class="my-2 d-md-none"
                @click="agregarNuevo"
              >
                Agregar
              </mdb-btn>
              <div class="d-none d-md-block col-md-11 col-lg-7">
                <div class="input-group my-1">
                  <mdb-input
                    v-model="email"
                    label="Email o Teléfono"
                    class="col my-0 px-0 input-mb-0 border-0-right"
                    outline
                  />
                  <div
                    class="md-form md-outline outline-select border-0-left
                      border-0-right col-4 my-0 px-0"
                  >
                    <select
                      v-model="host"
                      class="custom-select"
                    >
                      <option
                        class="d-none"
                        value=""
                      >
                        Seleccione
                      </option>
                      <option value="@gmail.com">
                        @gmail.com
                      </option>
                      <option value="@hotmail.com">
                        @hotmail.com
                      </option>
                    </select>
                  </div>
                  <div class="input-group-append">
                    <mdb-btn
                      size="md"
                      color="primary"
                      group
                      @click="agregarNuevo"
                    >
                      Agregar
                    </mdb-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template :slot="'Importar'">
          <div class="content-tab mb-1">
            <header
              class="my-2 font-weight-bold text-center"
            >
              Importe la lista de correos
            </header>
            <div class="inputs row justify-content-around">
              <div class="col-11 col-lg-8">
                <div class="input-group my-2">
                  <div class="custom-file my-1 outline-file md-form md-outline">
                    <input
                      id="addCSVfile"
                      type="file"
                      class="form-control custom-file-input"
                      aria-describedby="inputGroupFileAddon01"
                      @change="importarCSV($event)"
                    >
                    <label
                      for="addCSVfile"
                      class="custom-file-label"
                    >
                      Seleccione archivo
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </mdb-tabs>
      <!-- Botón para enviar invitaciones -->
      <transition name="slide-fade">
        <mdb-btn
          v-if="destinatarios.length"
          color="primary"
          class="my-0 btn-fixed-right-invitations"
          size="md"
          :disabled="btnDisabled"
          @click="validarEmails"
        >
          <font-awesome-icon
            v-if="btnDisabled"
            icon="circle-notch"
            class="mr-1"
            spin
            size="lg"
          />
          <font-awesome-icon
            v-else
            icon="envelope"
            class="mr-1"
            size="lg"
          />
          Enviar Invitaciones
        </mdb-btn>
      </transition>
      <!-- Lista de correos por invitar -->
      <div
        v-if="destinatarios.length"
        class="destinatarios mb-6"
      >
        <div
          v-for="(dest, index) in destinatarios"
          :key="dest.email"
          class="destinatario"
        >
          <div class="datos">
            <div>
              <p class="mb-0 text-break">
                {{ dest.name }}
              </p>
              <p class="mb-0 text-break fw-500">
                {{ dest.email }}
              </p>
            </div>
            <div class="d-flex align-items-center">
              <div
                class="custom-checkbox"
              >
                <input
                  :id="`dest-check-${index}`"
                  v-model="dest.status"
                  type="checkbox"
                >
                <label
                  :for="`dest-check-${index}`"
                  title="Preaprobado"
                />
              </div>
              <mdb-btn
                flat
                dark-waves
                text="danger"
                icon="minus-circle"
                title="Eliminar"
                class="ml-0"
                @click="remover(dest.email)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="mb-6 text-center"
      >
        Agrega direcciones de email o importa un archivo en formato CSV
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag';
import {mdbInput, mdbBtn, mdbTabs} from 'mdbvue';
import AlertaMsj from '@/components/AlertaMsj.vue';
import inviteDoctorsEmailsGql from '@/graphql/inviteDoctorEmails.gql';
import {emailSchema, arraySchema} from '@/utils/validations';
export default {
  name: 'Invitar',
  components: {
    AlertaMsj,
    mdbInput,
    mdbBtn,
    mdbTabs,
  },
  data() {
    return {
      nombre: '',
      email: '',
      host: '',
      destinatarios: [],
      cvsFile: '',
      btnDisabled: false,
      alertaMsj: {
        content: '',
      },
    };
  },
  methods: {
    agregarNuevo() {
      if (!this.email) {
        return this.alertaMsj = {
          content: 'El campo de email es obligatorio',
          type: 'warning',
        };
      }
      this.destinatarios.push({
        name: this.nombre.toString().trim(),
        email: (this.email.toString() + this.host.toString()).trim().toLowerCase(),
        status: false,
      });
      this.nombre = '';
      this.email = '';
    },
    importarCSV(e) {
      if (window.FileReader) {
        const reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        reader.onload = (ev) => {
          const csv = ev.target.result;
          this.parse_csv(csv);
        };
        reader.onerror = (e)=>{
          if (e.target.error.name == 'NotReadableError') {
            this.alertaMsj = {
              content: 'CSV no legible',
              type: 'warning',
            };
          }
        };
      } else {
        this.alertaMsj = {
          content: 'Este navegador web no soporta lectura de archivos',
          type: 'warning',
        };
      }
    },
    parse_csv(csv) {
      const lines = csv.split('\n');
      // const cabeceras = lines[0].split(',');
      lines.forEach((e) => {
        e = e.split(',');
        if (e[1]) {
          const mail = {
            name: (e[0] || '').trim(),
            email: e[1].trim().toLowerCase(),
          };
          if (e[2] && e[2].trim().toLowerCase() === 'preaprobado') {
            mail.status = 'Preaprobado';
          }
          this.destinatarios.push(mail);
        }
      });
    },
    async validarEmails() {
      let emailList = this.destinatarios.map((e) => {
        return {
          name: (e.name || '').trim(),
          email: (e.email || '').trim().toLowerCase(),
          status: e.status ? 'Preaprobado' : null,
        };
      });
      const schema = arraySchema().of(emailSchema);
      if (!(await schema.isValid(emailList))) {
        return this.alertaMsj = {
          content: 'Emails no válidos encontrados',
          type: 'danger',
        };
      }
      emailList = schema.cast(emailList);
      this.inviteDoctorsEmails(emailList);
    },
    inviteDoctorsEmails(emailList) {
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${inviteDoctorsEmailsGql}`,
        variables: {
          emails: emailList,
        },
      }).then((res) => {
        switch (res.data.inviteDoctorsEmail.msg) {
          case 'success':
            this.alertaMsj = {
              content: 'Invitaciones enviadas con éxito',
              type: 'success',
            };
            this.destinatarios = [];
            break;
          case 'partial':
            this.alertaMsj = {
              content: 'Invitaciones enviadas con al correo'+
                ' pero hubo un error guardando en la BD.',
              type: 'warning',
            };
            this.destinatarios = [];
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error enviando las invitaciones',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled = false;
      }).catch((error) => {
        this.btnDisabled = false;
        this.alertaMsj = {
          content: 'Hubo un error enviando las invitaciones',
          type: 'danger',
        };
      });
    },
    remover(email) {
      this.destinatarios = this.destinatarios.filter((e)=> {
        return e.email != email;
      });
    },
  },
};
</script>
<style lang="scss">
  .tab-invitaciones .nav.nav-pills.md-pills.pills-primary {
    display: flex;
    justify-content: center;
  }
  .btn-fixed-right-invitations {
    bottom: 5%;
    position: fixed;
    right: 6%;
    z-index: 1;
  }
  .destinatarios {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-end;

    @media (min-width: 992px) {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }

    .destinatario {
      width: 100%;

      @media (min-width: 992px) {
        width: 45%;
      }

      .datos {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: .5rem;
        margin-top: .5rem;
      }

      .custom-checkbox label {
        margin: 7px 0;

        &::before {
          padding: 0 6px;
        }
      }
    }


    .btn-flat {
      padding: .25rem;
    }
    .btn-flat.danger-text {
      color: #ff4444;
      &:hover {
        color: #CC0000;
      }
    }
  }
  /* Transition de entrada/salida del botón */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .custom-checkbox {
    position: relative;
    input[type*='checkbox'] {
      display: none;
    }
    label::before {
      color: $grey-base;
      cursor: pointer;
      font-family: "Font Awesome 5 Free";
      font-weight: 400;
      content: "\f0c8";
      transition: all .5s ease;
    }
    label:hover::before {
      color: $stylish-color;
    }
    input[type*="checkbox"]:checked + label::before {
      color: $success-color;
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f14a";
    }
  }
</style>
